// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Set defaults for raty.js
jQuery(document).ready(function () {
	jQuery.fn.raty.defaults.hints = ['Terrible', 'Poor', 'Okay', 'Good', 'Excellent'];
	jQuery.fn.raty.defaults.size = 36;
	jQuery.fn.raty.defaults.path = '/wp-content/themes/healthwatch-2020/dist/images';
	jQuery.fn.raty.defaults.space = false;		// we'll do the spacing in CSS
	jQuery.fn.raty.defaults.starOff = 'star-out.png';
	jQuery.fn.raty.defaults.starOn = 'star-in.png';
	jQuery.fn.raty.defaults.targetKeep = true;
});



// WEBPACK FOOTER //
// ./scripts/main.js